// extracted by mini-css-extract-plugin
export default {"container":"menuLink_container__L6wE5","active":"menuLink_active__48aB7"};